// extracted by mini-css-extract-plugin
module.exports = {"container":"UserAvatarLabelGroupLink_container__3-2gH","sending":"UserAvatarLabelGroupLink_sending__11i4W"};